module.exports = __webpack_public_path__ + "static/media/187-vanuatu.69b31b5d.svg";